import React from 'react'
import { Trans } from '@lingui/react'
import { KB_URL, MAILSHIP_CONTACT_URL } from '@constants/links'
import { Desktop, Message } from '@mailstep/design-system/ui/Elements/Icon'
import { Props as HeadingProps } from '@components/blocks/Heading'

const languageMap = {
  cs: 'CS',
  en: 'EN',
  it: 'IT',
}

export const createHelpSectionItems = ({ activeLanguage }: { activeLanguage: string }): HeadingProps['helpSectionItems'] => {
  const language = languageMap[activeLanguage as keyof typeof languageMap] || 'EN'

  return [
    {
      title: <Trans id="heading.menu.helpCenter" message="Help center" />,
      link: '#',
      onClick: (): void => window.open(`${KB_URL}/${language}`, '_blank')?.focus(),
      icon: <Desktop />,
    },
    {
      title: <Trans id="heading.menu.contactUs" message="Contact us" />,
      link: '#',
      onClick: (): void => window.open(MAILSHIP_CONTACT_URL, '_blank')?.focus(),
      icon: <Message />,
    },
  ]
}
